import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n';
import router from './router'
import { goToRouter } from './utils/tools';
import("@/assets/style/index.less");
import '@paykka/card-checkout-ui/style.css'
import lazyLoad from '@/directives/lazy-load'
import { initGA4 } from '@/utils/ga4-init'

// 加载 gtag.js + 初始化 dataLayer/gtag stub
// 必须在 new Vue 之前跑,否则页面首屏 page_view 会丢
initGA4()

// 全局注册指令
Vue.directive('lazy', lazyLoad)

Vue.config.productionTip = false
Vue.prototype.$goToRouter = goToRouter;

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
